import { Card, CardContent } from "@mui/material"
import LinearProgress from "@mui/material/LinearProgress"
import React, { FC } from "react"

import { SideNav } from "src/components/common/sideNav"

import { create } from "src/helpers/bem"

import { useCategories } from "src/states/shop/category"
import { useFilter } from "src/states/shop/filter"
import { TranslationMessages } from "src/translations"

import { getCategoryNavItems, selectCategory } from "./shopCategoryFilter"

import styles from "./ShopOverviewNavigation.module.scss"

const bem = create(styles, "ShopOverviewNavigation")

export type ShopOverviewNavigationProps = {
  messages: TranslationMessages
}

export const ShopOverviewNavigation: FC<ShopOverviewNavigationProps> = ({
  messages,
}) => {
  const m = messages.pages.shop.overview
  const { loading, categories } = useCategories()
  const { filterBy } = useFilter()

  if (loading) {
    return <LinearProgress color="primary" />
  }

  if (!categories || categories?.length === 0) {
    return <></>
  }

  const navItems = getCategoryNavItems(
    categories,
    filterBy?.category,
    (category) => selectCategory(category.id),
  )

  return (
    <Card className={bem("card")}>
      <CardContent className={bem("content")}>
        <SideNav items={navItems} />
      </CardContent>
    </Card>
  )
}
